import { render, staticRenderFns } from "./EmployeeAddressForm.vue?vue&type=template&id=98d8f4f6&"
import script from "./EmployeeAddressForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAddressForm.vue?vue&type=style&index=0&id=98d8f4f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports